import React, { useState } from 'react';
import {
  PT_WHEN_CANCEL,
  PT_WHEN_DELETE,
  PT_WHEN_DELETE_NOTE,
  PT_WHEN_DOWN,
  PT_WHEN_MANAGE,
  PT_WHEN_RENAME_ARIA,
  PT_WHEN_SAVE,
  PT_WHEN_UP,
} from '../../utils/writerCopy';

/**
 * The book's When labels: rename, reorder (buttons, not drag: works in High Contrast and
 * from the keyboard), delete (clears the label from its scenes). Spec §1.
 */
export default function PlotTrackWhenLabels({ labels, onRename, onReorder, onDelete }) {
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const list = labels || [];
  if (list.length === 0) return null;

  const run = async (fn) => {
    setBusy(true);
    try { await fn(); } finally { setBusy(false); }
  };
  const move = (index, delta) => run(async () => {
    const ids = list.map((label) => label.id);
    const [moved] = ids.splice(index, 1);
    ids.splice(index + delta, 0, moved);
    await onReorder(ids);
  });

  return (
    <details className="pt-when-labels">
      <summary>{PT_WHEN_MANAGE}</summary>
      <p className="pt-when-labels__note">{PT_WHEN_DELETE_NOTE}</p>
      <ol className="pt-when-labels__list">
        {list.map((label, index) => (
          <li key={label.id} className="pt-when-labels__item">
            {editing === label.id ? (
              <>
                <input
                  type="text"
                  value={draft}
                  maxLength={80}
                  aria-label={PT_WHEN_RENAME_ARIA(label.label)}
                  disabled={busy}
                  onChange={(e) => setDraft(e.target.value)}
                />
                <button type="button" className="pt-when__btn" disabled={busy || !draft.trim()}
                  onClick={() => run(async () => { await onRename(label.id, draft.trim()); setEditing(null); })}
                >{PT_WHEN_SAVE}</button>
                <button type="button" className="pt-when__btn pt-when__btn--quiet" disabled={busy}
                  onClick={() => setEditing(null)}
                >{PT_WHEN_CANCEL}</button>
              </>
            ) : (
              <>
                <button type="button" className="pt-when-labels__name" disabled={busy}
                  aria-label={PT_WHEN_RENAME_ARIA(label.label)}
                  onClick={() => { setEditing(label.id); setDraft(label.label); }}
                >{label.label}</button>
                <button type="button" className="pt-when__btn pt-when__btn--quiet" disabled={busy || index === 0}
                  onClick={() => move(index, -1)} aria-label={`${PT_WHEN_UP}: ${label.label}`}
                >↑</button>
                <button type="button" className="pt-when__btn pt-when__btn--quiet" disabled={busy || index === list.length - 1}
                  onClick={() => move(index, 1)} aria-label={`${PT_WHEN_DOWN}: ${label.label}`}
                >↓</button>
                <button type="button" className="pt-when__btn pt-when__btn--quiet" disabled={busy}
                  onClick={() => run(() => onDelete(label.id))} aria-label={`${PT_WHEN_DELETE}: ${label.label}`}
                >{PT_WHEN_DELETE}</button>
              </>
            )}
          </li>
        ))}
      </ol>
    </details>
  );
}
